var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',_vm._b({model:{value:(_vm.hover),callback:function ($$v) {_vm.hover=$$v},expression:"hover"}},'v-hover',_vm.$attrs,false),[_vm._t("default",null,{"hover":_vm.hover,"toggle":_vm.toggle})],2)}
var staticRenderFns = []

export { render, staticRenderFns }